import { weekGoalError } from "@/lib/points";
import type { CounterConfig } from "@/lib/schema";
import type { WidgetValidationResult } from "@/widgets/types";
import { maxScoreWeek } from "./scoring";

export function validate(config: CounterConfig): WidgetValidationResult {
  const errors: Record<string, string> = {};
  if (config.label.trim().length === 0) {
    errors.label = "Etikett kan ikke være tom.";
  }
  if (!Number.isInteger(config.points) || config.points < 1) {
    errors.points = "Poeng må være et helt tall på minst 1.";
  }
  if (!Number.isFinite(config.maxPoints)) {
    errors.maxPoints = "Maks per dag kreves.";
  } else if (!Number.isInteger(config.maxPoints)) {
    errors.maxPoints = "Maks per dag må være et helt tall.";
  } else if (config.maxPoints < config.points) {
    errors.maxPoints =
      "Maks per dag må være minst like stor som poeng per enhet.";
  }
  const goalError = weekGoalError(config.weekGoal, {
    max: maxScoreWeek(config),
  });
  if (goalError) errors.weekGoal = goalError;
  if (Object.keys(errors).length === 0) return { ok: true };
  return { ok: false, errors };
}
